import { configureStore } from "@reduxjs/toolkit";
import privilegesReducer from "../features/privileges/privilegesSlice"; // Import the privileges slice
import notificationReducer from "../features/slices/notificationSlice";
import scheduleFilterReducer from "../features/slices/scheduleFilterSlice";
import workforceFilterReducer from "../features/slices/workforceFilterSlice";
import myScheduleFilterReducer from "../features/slices/myScheduleFilterSlice";
import exportReducer from "../features/slices/exportSlice";

export const store = configureStore({
    reducer: {
        privileges: privilegesReducer,
        notifications: notificationReducer,
        scheduleFilters: scheduleFilterReducer,
        myScheduleFilter: myScheduleFilterReducer,
        workforceFilters: workforceFilterReducer,
        export: exportReducer,

    },
});